import { render, staticRenderFns } from "./News.vue?vue&type=template&id=ce7ba7ca&scoped=true"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"
import style0 from "./News.vue?vue&type=style&index=0&id=ce7ba7ca&prod&lang=stylus&scoped=true"
import style1 from "./News.vue?vue&type=style&index=1&id=ce7ba7ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7ba7ca",
  null
  
)

export default component.exports